import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
  showBanner:number = 1
  constructor() { }
  interval:any
  ngOnInit() {
    this.interval = setInterval(() => {this.next2()},4000)
  }
  next(n:number){
  	this.showBanner = n
  }
  next2(){
    if(this.showBanner == 3)
      this.showBanner = 1
    else
      this.showBanner++
  }
}



// WEBPACK FOOTER //
// ./src/app/banner/banner.component.ts